<template>

    <div class="overlay">

        <div class="modal">

            <header class="modal-header">

                <img src="assets/img/logo.svg" alt="Privatbrauerei Zissel">

                <hr>

                <p>Ihre Privatbrauerei Zissel setzt sich im Rahmen der gesetzlichen
                Bestimmungen für den verantwortungsbewussten Umgang mit alkoholischen
                Getränken ein. Auf den folgenden Seiten finden Sie Information
                über alkoholische Getränke.</p>

                <p>Wir bitten Sie daher zu bestätigen, dass Sie über 16 Jahre alt sind!</p>
            </header>

            <div class="modal-content">
                <transition name="push" mode="out-in">

                    <div v-if="!underAge" class="modal-content--btn" key="buttons">

                        <router-link :to="'/' + destination" class="btn">
                            <span>Ja, ich bin mindestens 16 Jahre alt.</span>
                        </router-link>

                        <a @click="underAge = !underAge" class="btn">
                            <span>Nein, leider noch nicht.</span>
                        </a>

                    </div>

                    <div v-if="underAge" class="modal-deny" key="deny">
                            <p>Der Internetauftritt steht leider nur Personen zu Verfügung,
                                die mindestens 16 Jahre alt sind.</p>
                    </div>

                </transition>
            </div>

        </div>

    </div>



</template>


<script>
import { mapGetters } from 'vuex'
import store from '../../store'

export default {


    data() {
        return {
            underAge: false
        }
    },

    computed: {

        destination() {
            return this.$route.query.confirm || 'einkehren'
        }

    },

    beforeRouteLeave(to, from, next) {

        store.dispatch('confirmAge')

        next()
    }

}

</script>



// WEBPACK FOOTER //
// age-confirmation.vue?6b5d2bfc